// extracted by mini-css-extract-plugin
export default {"imageWrapper":"QrPage_imageWrapper__ZPHxA","fieldGroup":"QrPage_fieldGroup__jv--r","qrWrapper":"QrPage_qrWrapper__4XnzL","goLink":"QrPage_goLink__4WZCD"};